import { MCAXS130DownloadCsvRequest } from 'types/MCAXS130/MCAXS130DownloadCsvRequest'

const MCAXS130downloadValues: MCAXS130DownloadCsvRequest = {
  requestId: '',
  template: '',
  // 28P #129402 start
  targetCount: '',
  callDivision: '',
  historyOutputCategory: '',
  seminarRequestList: []
  // 28P #129402 end
}

export { MCAXS130downloadValues }
